import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
} from "@angular/core";
import { ControlContainer, FormGroupDirective } from "@angular/forms";

import { faRectangleList, faSearch } from "@fortawesome/pro-light-svg-icons";

import { faGripLinesVertical } from "@fortawesome/pro-light-svg-icons";

import {
  faEdit,
  faPencil,
  faCircleInfo,
} from "@fortawesome/pro-regular-svg-icons";

import { CommonService } from "@services/common.service";

@Component({
    selector: "app-list-chart",
    templateUrl: "./list-chart.component.html",
    styleUrls: ["./list-chart.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class ListChartComponent implements OnInit, OnChanges {
  @Input() data: any = [];
  @Input() chartData: any = [];
  @Input() dataPoints?: any = [];
  @Input() type?: string;
  @Input() fullSize?: boolean;
  @Input() preview?: boolean;
  @Input() hasEdit?: boolean = true;
  @Input() canvasMode!: any;
  @Input() canvasType!: any;

  constructor(
    private cdRef: ChangeDetectorRef,
    public commonService: CommonService,
    public parentF: FormGroupDirective
  ) {}

  childForm: any;

  public minwidth: any;
  public title: string = "";
  public description: string = "";
  public referenceLink = "";
  faRectangleList = faRectangleList;
  faEdit = faEdit;
  faPencil = faPencil;

  faCircleInfo = faCircleInfo;
  displayDrilldown = true;
  drilldownLink = "http://www.quantivate.com";

  faSearch = faSearch;
  faGripLinesVertical = faGripLinesVertical;
  public featureFlags: any = [];

  public rowsToDisplay: any[] = [];
  public rowToDisplay: any[] = [];

  getColumns() {
    if (this.data && this.data != "empty" && this.data.length > 0) {
      this.rowToDisplay = [];
      this.rowsToDisplay = [];
      this.referenceLink = "";
      this.data.forEach((entries: any) => {
        this.rowToDisplay = Object.entries(entries);
        this.rowsToDisplay.push(this.rowToDisplay);
      });

      if (this.rowsToDisplay[0][0][0] == "referenceLink") {
        this.referenceLink = this.rowsToDisplay[0][0][1].value;
      }

      if (this.canvasMode == "edit")
        this.rowsToDisplay = this.rowsToDisplay.slice(0, 1);
    }
  }

  ngOnChanges() {
    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
    this.childForm = this.parentF.form;
    if (this.childForm)
      this.title = this.chartData.title || this.childForm.get("title").value;

    if (
      this.chartData &&
      this.chartData.modifications.data.formatters.data &&
      this.chartData.modifications.data.formatters.data.length > 0
    ) {
      this.title = this.chartData.modifications.data.formatters.data[0].value;
      if (this.chartData.modifications.data.formatters.data[1]) {
        this.description =
          this.chartData.modifications.data.formatters.data[1].value;
      }
    }
    this.getColumns();
  }

  ngOnInit() {
    this.childForm = this.parentF.form;
    this.featureFlags = JSON.parse(sessionStorage.getItem("featureFlags"));

    this.getColumns();
  }
}
